var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43334 4.41672L4.30434 1.28772L5.12917 0.462891L9.66634 5.00006L5.12917 9.53722L4.30434 8.71239L7.43334 5.58339H0.333008V4.41672H7.43334Z",
    fill: "#6D6D73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortArrowRight);
export default __webpack_public_path__ + "static/media/short-arrow-right.5a2eefda95a6441ab4082aa27c09cf0a.svg";
export { ForwardRef as ReactComponent };